var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":_vm.type,"variant":_vm.processedVariant},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }